import { useRef } from 'react';

// Close a modal only when a click both starts and ends on its backdrop.
// A plain onClick also fires when the mouse is pressed inside the modal
// (e.g. selecting text in an input) and released outside it.
export default function useBackdropClose(onClose) {
  const pressStartedOnBackdrop = useRef(false);

  return {
    onMouseDown: (event) => {
      pressStartedOnBackdrop.current = event.target === event.currentTarget;
    },
    onClick: (event) => {
      if (pressStartedOnBackdrop.current && event.target === event.currentTarget) {
        onClose?.();
      }
      pressStartedOnBackdrop.current = false;
    },
  };
}
